<mat-card>
  <mat-card-header>
    <div class="flex" style="width: 100%;justify-content: center;">
      <span style="font-size:1rem !important;"> <strong>ยืนยันการบันทึกรายงานตรวจปล่อยสินค้า</strong></span>
    </div>
  </mat-card-header>
  <mat-dialog-content>
    <div class="pl-22 pr-22 pt-4 flex flex-col gap-4">
      <div class="flex gap-2.5" style="flex-direction: column;">
        <div>
          <span style="font-size: 1.25rem;"><strong>คุณต้องการบันทึกรายงานการตรวจปล่อยสินค้าครั้งที่ {{formData.index +
              1}} ใช่หรือไม่ ?</strong></span>
        </div>

        <div>
          <p>โปรดทราบ ข้อมูลทั้งหมดนี้จะถูกส่งเข้าระบบ OCS Connect เพื่อใช้ในการออกรายงาน มส.17 ต่อไป
            กรุณาตรวจสอบข้อมูลก่อนการบันทึก <span style="color: red; font-weight: bold;">หากบันทึกผลการตรวจสอบแล้ว
              ท่านจะไม่สามารถแก้ไขข้อมูลการตรวจสอบผ่านระบบ CSC Online ของสภาหอการค้าแห่งประเทศไทยได้อีก</span></p>
        </div>

        <div class="flex flex-col">
          <div>
            <p><span style="font-weight: bold;">เลขที่แจ้งงานตรวจปล่อยสินค้า: {{formData.petitionNo}}</span>
              (วันและเวลาที่ได้รับแจ้ง: {{formData.petitionDate | thaidate}} เวลา {{formData.petitionDate |
              date:'HH:mm'}} น.)</p>
          </div>
          <div>
            <span>บริษัทผู้ตรวจสอบ: {{formData.companyName}}</span>
          </div>
          <div>
            <span>ผู้รับงานตรวจสอบ/ผู้บันทึกผลการตรวจสอบ: {{formData.surveyAcceptName}}</span>
          </div>
        </div>

        <div class="flex justify-between">
          <div class="flex flex-col gap-4">
            <div>
              <div style="font-weight: bold;">
                <span>การตรวจปล่อยสินค้า</span>
              </div>
              <div>
                <span>ผู้สั่งงานตรวจปล่อย: {{formData.surveyOrder}}</span>
              </div>
              <div>
                <span>วันและเวลาที่สั่งงานตรวจปล่อย: {{formData.surveyOrderDate | thaidate}} เวลา
                  {{formData.surveyOrderTime}} น.</span>
              </div>
            </div>

            <div>
              <div style="font-weight: bold;">
                <span>ผู้ตรวจปล่อยสินค้า</span>
              </div>
              <ng-container *ngFor="let person of formData.surveyorBList; let j = index">
                <div *ngIf="j === 0 || (person.empNo != '' && person.empNo != null && person.empNo != undefined)">
                  <span *ngIf="j === 0">ลำดับที่ {{j + 1}} {{person.name}} เลขที่ผตข. {{person.empNo}}
                    เป็นหัวหน้าสาย</span>
                  <span *ngIf="j > 0">ลำดับที่ {{j + 1}} {{person.name}} เลขที่ผตข. {{person.empNo}} เป็นลูกสายลำดับที่
                    {{j}}</span>
                </div>
              </ng-container>
            </div>
          </div>
          <div class="flex flex-col gap-4">
            <div>
              <div style="font-weight: bold;">
                <span>การวิเคราะห์สินค้า</span>
              </div>
              <div>
                <span>ผู้สั่งงานวิเคราะห์: {{formData.surveyAnalyzeOrder}}</span>
              </div>
              <div>
                <span>วันและเวลาที่สั่งงานวิเคราะห์: {{formData.surveyAnalyzeOrderDate | thaidate}} เวลา
                  {{formData.surveyAnalyzeOrderTime}} น.</span>
              </div>
            </div>

            <div>
              <div style="font-weight: bold;">
                <span>ผู้วิเคราะห์สินค้า</span>
              </div>
              <div>
                <span>{{formData.surveyAnalyze}} เลขที่ผตก. {{formData.surveyAnalyzeNo}} เป็นหัวหน้าสาย</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="flex justify-center gap-2.5">
        <mat-checkbox [(ngModel)]="agreementCheck">
          ข้าพเจ้าขอรับรองว่าข้อมูลข้างต้นถูกต้องทุกประการ
        </mat-checkbox>
      </div>

      <div class="flex justify-center gap-2.5" style="gap: 10px;">
        <button mat-raised-button color="accent" [disabled]="!agreementCheck" (click)="sendOcs()">ยืนยัน</button>
        <button mat-raised-button [mat-dialog-close]>ยกเลิก</button>
      </div>
    </div>
  </mat-dialog-content>